import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=fe7e980e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7e980e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe7e980e')) {
      api.createRecord('fe7e980e', component.options)
    } else {
      api.reload('fe7e980e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=fe7e980e&scoped=true&", function () {
      api.rerender('fe7e980e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2btxGZi0FcoWy/JS/comp/Accordion.vue"
export default component.exports